import {
  Row,
  Col,
  Statistic,
  Button,
} from "antd";
import { createElement, Props as ReactProps } from "react";
import styled from 'styled-components';
import Order from '../../../../entity/order';
import ProductCategory from "../../../../entity/productCategory";
import {
  BASE_BORDER_COLOR,
} from '../../../constants/color';
import { SearchProductType } from '../../../../state/contentSelect';

type Props = ReactProps<HTMLSpanElement> & {
  order: Order;
  updateSearchProduct: (searchParams: SearchProductType) => void;
  searchProduct: SearchProductType;
  productCategories: ProductCategory[];
  save: () => Promise<void>;
};

const StyledSearchContainer = styled(Row)`
  width: 100%;
  padding-bottom: 20px;
`;

const StyledItemTotalWrapper = styled(Col)`
  width: auto;
  margin-right: 10px;
  font-size: 20px;
`;

const StyledCategoryContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  margin: 10px 0;
`;

const StyledCategoryItem = styled.div<any>`
  padding: 20px 10px;
  width: 100%;
  border-bottom: 1px solid ${BASE_BORDER_COLOR};
  background: ${props => props.active && 'grey' };
  color: ${props => props.active && 'white' };
  cursor: pointer;
`;

const ContentSelectForm = (props: Props) => {
  const {
    order,
    searchProduct,
    updateSearchProduct,
    productCategories,
    save,
  } = props;
  const categoriesOptions = [new ProductCategory({ id: "*", name: "全て" })].concat(productCategories).map((item: ProductCategory) => {
    return (
      <StyledCategoryItem
        onClick={() => updateSearchProduct({ searchInput: { categoryId: item.id as string } })}
        key={`category-select-${item.id as string}`}
        active={(searchProduct.searchInput && (searchProduct.searchInput.categoryId || '*')) === item.id}
      >
        {item.name}
      </StyledCategoryItem>
    )
  });

  return (
    <StyledSearchContainer type="flex">
      <StyledItemTotalWrapper>
        <Statistic
          value={order.totalProductPrice + order.totalTaxPrice}
          prefix="合計金額：¥"
          valueStyle={{ fontSize: 16, display: 'inline' }}
          style={{ display: 'inline' }}
        />
      </StyledItemTotalWrapper>
      <StyledItemTotalWrapper>
        <Statistic
          value={order.totalProductCount}
          prefix="合計個数："
          valueStyle={{ fontSize: 16, display: 'inline' }}
          style={{ display: 'inline' }}
        />
      </StyledItemTotalWrapper>
      <StyledCategoryContainer>
        {categoriesOptions}
      </StyledCategoryContainer>
      <Button onClick={save}>
        カートを見る
      </Button>
    </StyledSearchContainer>
  );
};

export default ContentSelectForm;
